import React, { useState } from "react"
import styled from "styled-components"
import { ToolTechCardComponent } from "../../atoms"
import { Grid } from "antd"
import {
  Communication,
  CommunicationMob,
  Backend,
  Frontend,
  Design,
  Other,
} from "./data"
import Slider from "react-slick"

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { AosWrapper } from "../../molecules/AosWrapper"
import { Headline, StyledGradientTitle } from "../../../utils"

const Wrapper = styled.div`
  width: 100%;
  background: ${(props) => props.theme.footerSectionColor};
`

const TechToolSection = styled.div`
  max-width: 1500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  align-items: center;
  padding: 80px 0px;
  width: 100%;
  @media (min-width: 601px) and (max-width: 1023px) {
    padding: 50px 0;
  }

  @media (max-width: 600px) {
    padding: 40px 0;
  }
  .slick-slider {
    position: relative;
    margin: 0 auto;
    width: 100%;
    margin-top: 40px;
    @media (max-width: 1023px) {
      padding: 0px;
      margin-top: 20px;
    }
  }

  .slick-slide {
    width: 100%;
    padding: 12px;
    @media (max-width: 425px) {
      padding: 10px;
    }
  }

  .horizontal-indicator {
    display: flex;
    justify-content: center;
  }

  .indicator {
    width: 40px;
    height: 6px;
    background: ${(props) => props.theme.gray29};
    margin: 10px;
    border-radius: 5px;
    padding: 0px;
    ::before {
      content: "";
    }
  }
  .slick-list .slick-track div .slick-active {
    @media (min-width: 475px) {
      width: 320px !important;
    }
    @media (min-width: 768px) {
      width: 400px !important;
    }
  }
  .slick-active .indicator {
    background: ${(props) => props.theme.indicatorGradient};
  }
  .slick-list {
    padding: 10px;
    @media (max-width: 375px) {
      padding: 6px;
    }
  }
  .slick-arrow {
    display: none !important;
    right: 0;
  }
  .slick-dots li {
    width: auto;
  }

  .slick-slide > div {
    display: flex;
    justify-content: center;
    height: 100%;
  }

  .slick-center {
    transition: 1s all ease;
  }
`

const TechToolHeader = styled.div`
  text-align: center;
  width: 100%;
  @media (max-width: 600px) {
    padding: 0 20px;
  }
`
const HeadlineText = styled(Headline)`
  margin: 0px;
  @media (min-width: 601px) and (max-width: 1023px) {
    white-space: break-spaces;
  }
`

const TechToolSectionComponent: React.FC = () => {
  let backend = Backend,
    frontend = Frontend,
    comData = Communication(),
    design = Design,
    other = Other
  const { useBreakpoint } = Grid
  const screenSize = useBreakpoint()
  if (screenSize.xs) {
    backend = Backend
    frontend = Frontend
    comData = CommunicationMob
    design = Design
    other = Other
  }

  const items = [
    {
      id: 1,
      title: "Communication & skills",
      data: comData,
    },
    {
      id: 2,
      title: "Backend ",
      data: backend,
    },
    {
      id: 3,
      title: "Frontend",
      data: frontend,
    },
    {
      id: 4,
      title: "Design",
      data: design,
    },
    {
      id: 5,
      title: "Others",
      data: other,
    },
  ]

  const [currentSlide, setCurrentSlide] = useState(1)

  const handleSlideChange = (index) => {
    setCurrentSlide(index)
  }

  const settings = {
    swipeToSlide: true,
    className: "center",
    centerMode: true,
    infinite: true,
    slidesToShow: 2,
    dots: true,
    speed: 500,
    variableWidth: false,
    centerPadding: "400px",
    autoplay: true,
    initialSlide: 2,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2.5,
          initialSlide: 2,
          dots: true,
          centerPadding: "300px",
          className: "center",
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          initialSlide: 2,
          dots: true,
          centerPadding: "300px",
          className: "center",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          initialSlide: 2,
          dots: true,
          centerPadding: "200px",
          className: "center",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          initialSlide: 2,
          centerPadding: "40px",
          dots: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          initialSlide: 2,
          centerPadding: "20px",
          dots: true,
          className: "center",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          initialSlide: 2,
          centerPadding: "10px",
          dots: true,
          className: "center",
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          initialSlide: 2,
          centerPadding: "10px",
          dots: true,
          className: "center",
          centerMode: true,
        },
      },
    ],
    appendDots: (dots) => (
      <div className={"horizontal-indicator"}>
        <ul>{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <button
        key={i}
        className={`indicator ${i === currentSlide ? "active" : ""}`}
        onClick={() => handleSlideChange(i)}
      />
    ),
  }

  return (
    <Wrapper id={"tech-tool"}>
      <AosWrapper>
        <TechToolSection>
          <TechToolHeader>
            <HeadlineText>
              {"Wide Range of "}
              <StyledGradientTitle>{"Tech & Tools"} </StyledGradientTitle>
              {" Supporting \n"}
              {"Our Problem-Solving Skills"}
            </HeadlineText>
          </TechToolHeader>
          <Slider {...settings}>
            {items.map((item) => (
              <ToolTechCardComponent
                key={item.id}
                keyId={item.id}
                title={item.title}
                iconDetails={item.data}
              />
            ))}
          </Slider>
        </TechToolSection>
      </AosWrapper>
    </Wrapper>
  )
}
export { TechToolSectionComponent }
